
import { Component, Prop } from 'vue-property-decorator';
import { InputType } from '@/enums/InputType';
import VFormBuilder from '@/components/shared/form/VFormBuilder.vue';
import { mixins } from 'vue-class-component';
import StackedForm from '@/mixins/StackedForm';
import { Category } from '@/interfaces/models/Category';
import { namespace } from 'vuex-class';
import Notification from '@/mixins/Notification';
import VenueApiService from '@/api/http/VenueApiService';
import _ from 'lodash';

const api = new VenueApiService();
const app = namespace('app');

@Component({
  components: { VFormBuilder },
})
export default class SimphonyDialog extends mixins(StackedForm, Notification) {
  @Prop({ type: String, required: true }) public venueId!: string;
  @Prop({ required: true }) public venue: any;

  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & {
      setData: (form: any) => void;
    };
  };
  public show: boolean = false;
  get items() {
    let simphonyProperties;
    if (this.venue.checkoutIntegrationProperties && this.venue.checkoutIntegrationProperties.simphony) {
      simphonyProperties = this.venue.checkoutIntegrationProperties.simphony;
    }

    return [
      {
        name: 'orgShortName',
        type: InputType.Text,
        label: 'article.simphony.orgShortName',
        rules: 'required',
        default: simphonyProperties ? simphonyProperties.orgShortName : '',
      },
      {
        name: 'locRef',
        type: InputType.Text,
        label: 'article.simphony.locRef',
        default: simphonyProperties ? simphonyProperties.locRef : '',
      },
      {
        name: 'rvcRef',
        type: InputType.Text,
        label: 'article.simphony.rvcRef',
        rules: 'required',
        default: simphonyProperties ? simphonyProperties.rvcRef : '',
      },
      {
        name: 'service_url',
        type: InputType.Text,
        label: 'article.simphony.serviceUrl',
        rules: 'required',
        default: simphonyProperties ? simphonyProperties.serviceUrl : '',
      },
      {
        name: 'importLanguage',
        type: InputType.Select,
        label: 'article.simphony.importLanguage',
        rules: 'required',
        items: ['de', 'en', 'fr'],
        default: 'de',
      },
    ];
  }

  public setShowModal(showModal: boolean = true) {
    this.show = showModal;
    if (!showModal) {
      this.$refs.form.reset();
      this.$refs.form.clearErrors();
    }
  }

  public async save() {
    if (!(await this.$refs.form.validate())) {
      return;
    }

    try {
      const data = _.cloneDeep(this.$refs.form.getData());
      const accessToken = this.venue.checkoutIntegrationProperties?.simphony?.accessToken;

      this.$startLoading('import_foodcard');

      await api.importFoodcardSimphony(this.venueId, { ...data, ...(accessToken && { accessToken }) });

      this.setShowModal(false);
      this.$emit('updateFoodcard');
      this.notifySuccess('article.simphony.success');
    } finally {
      this.$stopLoading('import_foodcard');
    }
  }
}
